import Table, { joinRows } from './Table';
import { formatCellValue } from './TableCell';

export default Table;
export { formatCellValue, joinRows };
